import {
    COUNTRY_MAPPING_LIST_SUCCESS,
    COUNTRY_MAPPING_LIST_FAILED,
    LOADING_COUNTRY_MAPPING_LIST,
    NETWORK_ERROR_COUNTRY_MAPPING_LIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminCountryMappingListAction =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_COUNTRY_MAPPING_LIST });
        await adminServices
            .post("countryMappingList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: COUNTRY_MAPPING_LIST_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: COUNTRY_MAPPING_LIST_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_COUNTRY_MAPPING_LIST,
                    payload: err
                });
            });
    };

export { adminCountryMappingListAction };
